import {connect} from 'react-redux';
import {WaterBath as Component} from './WaterBath';
import {
  createWaterBath,
  // setWaterBathControlVisibility,
  setHeld,
  setHeldObject,
  // showMoveMenu,
  hideAllControls,
  waterBathOpen, setModal, showModal,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  // console.log('in index waterbath: ', ownProps);
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("waterBath") &&
     state.notebook.protocolSection.scene.apparatus.waterBath.some(
       waterBath => waterBath.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.waterBath[ownProps.id - 1].type,
      rackInBath: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id - 1].inWaterBath,
      // rackInBath: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id-1].inWaterBath,
      open: state.notebook.protocolSection.scene.apparatus.waterBath[ownProps.id - 1].open,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createWaterBath: (data) => {
      dispatch(createWaterBath(data))
    },
    waterBathOpen: (data) => {
      dispatch(waterBathOpen(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    setModal: (data) => {
      dispatch(    setModal(data))
    },

    showModal: (data) => {
      dispatch(    showModal(data))
    },
  };
}

export const WaterBath = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
